<template>
  <div>
    <div v-if="title.length > 0" class="sorter-title mb-3">
      {{ title }}
    </div>
    <draggable
      :list="items"
      handle=".draggable-element"
      class="sorter-container"
      :group="groupId"
      @start="$emit('start')"
      @end="$emit('end')"
    >
      <template v-for="item in items">
        <div :key="item.id" class="sorter-row">
          <div class="draggable-element">
            <v-icon size="24">$vuetify.icons.DragHandle</v-icon>
          </div>
          <div class="sorter-text">
            {{ item.title }}
          </div>
          <v-spacer />
          <div>
            <action-col-btn
              :id="`btn-draggable-${groupId}-remove-${item.id}`"
              tooltip="Удалить из списка"
              color="#676767"
              @click="$emit('remove-item', item)"
            >
              mdi-trash-can-outline
            </action-col-btn>
          </div>
        </div>
      </template>
    </draggable>
    <div v-for="(error, index) in errorMessages" :key="index">
      <span class="v-messages error--text">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import uniqueId from "lodash/uniqueId";

export default {
  name: "SorterList",
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    groupName: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    items: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    groupId() {
      return this.groupName === null ? uniqueId() : this.groupName;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../styles/branding.scss";

.sorter-title {
  font-weight: 700;
  font-size: 14px;
}
.sorter-container {
  .sorter-row {
    display: flex;
    height: 40px;
    align-items: center;

    .sorter-text {
      font-size: 16px;
    }

    border-top: 1px solid #eaeaeb;

    &:last-of-type {
      border-bottom: 1px solid #eaeaeb;
    }
  }
}
.draggable-element {
  cursor: grab;
  padding: 4px;
  margin-right: 8px;
}
.sorter__error-message {
  color: $brand-status-danger;
}
</style>
